import { render } from "./parentNodeHistory.vue?vue&type=template&id=662728ea&ts=true"
import script from "./parentNodeHistory.vue?vue&type=script&lang=ts"
export * from "./parentNodeHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__